import React, { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { useTranslation } from 'react-i18next';
import useI18next from 'services/i18n';
import { Text, Button, Box } from '@user-portal/wikr-components';
import { ERROR_LEVELS, SENTRY_CABINET } from '@user-portal/sentry-utils';

import AuthLayout from 'router/layouts/AuthLayout';

import sentry from 'services/Sentry/SentryInstance';

import AlertIcon from 'components/Icon/Alert';
import ContactUsLink from 'components/ContactUsLink';

import * as S from './styled';
import { logger } from '@user-portal/logger';

export const ErrorPage = () => {
    const { t } = useTranslation();

    useI18next();

    const error = useRouteError();

    useEffect(() => {
        sentry.logError(new Error(error?.toString()), SENTRY_CABINET, ERROR_LEVELS.CRITICAL);
        logger.error('Error boundary caught error', { error });
    }, [error]);

    return (
        <AuthLayout titleKey="basics.appError">
            <S.ErrorBoundaryWrapper>
                <Box
                    $backgroundColor="surface-secondary"
                    $withShadow
                    $paddingX={16}
                    $paddingTop={40}
                    $paddingBottom={40}
                    $borderRadius={12}
                >
                    <Box $mb={12}>
                        <AlertIcon size={50} />
                    </Box>
                    <Text color="text-main" type="h6" bold center mb={32} uppercase>
                        {t('basics.appError')}
                    </Text>

                    <Button onClick={window.location.reload} mb={24}>
                        {t('basics.reload')}
                    </Button>

                    <ContactUsLink boldText />
                </Box>
            </S.ErrorBoundaryWrapper>
        </AuthLayout>
    );
};
